import type { ObservationsV1IssueFeedbackInput } from '@spotify/confidence-graphql';

export type ReviewDecision =
  | 'request_changes'
  | 'approve_build'
  | 'approve_full';

type FeedbackSelection = {
  from: number;
  to: number;
  quote: string;
};

export type NewFeedback = FeedbackSelection & {
  feedback: string;
};

export type DraftFeedback = NewFeedback & {
  id: string;
};

export const buildIssueReviewFeedback = (
  feedbackItems: DraftFeedback[],
  generalFeedback: string,
): ObservationsV1IssueFeedbackInput[] => {
  const targetedFeedback = feedbackItems.map(({ quote, feedback }) => ({
    quote,
    comment: feedback.trim(),
  }));
  const trimmedGeneralFeedback = generalFeedback.trim();

  return [
    ...targetedFeedback,
    ...(trimmedGeneralFeedback
      ? [{ quote: '', comment: trimmedGeneralFeedback }]
      : []),
  ];
};
